export class AccessToken {
	state!: string;
	expiration!: string;
	token!: string;
	refreshToken!: string;
	refreshTokenExpiration!: string;
}